import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import api from "../api/client";

const cardStyle = {
  background: "#fff",
  borderRadius: 18,
  padding: 20,
  boxShadow: "0 10px 30px rgba(15,23,42,0.08)",
  border: "1px solid #e2e8f0",
};

const AdminDashboard = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const location = useLocation();
  const basePath = location.pathname.startsWith("/super-admin") ? "/super-admin" : "/admin";

  useEffect(() => {
    const load = async () => {
      try {
        const response = await api.get("/api/admin/dashboard");
        setData(response.data);
      } catch (err) {
        setError(err?.response?.data?.error || "Failed to load dashboard");
      }
    };
    load();
  }, []);

  if (error) return <div style={{ padding: 24, color: "red" }}>{error}</div>;
  if (!data) return <div style={{ padding: 24 }}>Loading dashboard...</div>;

  const { totals, sellerReport, recentOrders } = data;
  const cards = [
    ["Revenue", `Rs.${Number(totals.revenue || 0).toFixed(2)}`, `${basePath}/orders?status=paid`],
    ["Orders", totals.orders, `${basePath}/orders`],
    ["Customers", totals.customers, `${basePath}/customers`],
    ["Sellers", totals.sellers, `${basePath}/sellers`],
    ["Products", totals.products, `${basePath}/products`],
    ["Retail Products", totals.retailProducts, `${basePath}/products?filter=retail`],
    ["Wholesale Products", totals.wholesaleProducts, `${basePath}/products?filter=wholesale`],
    ["Trade Buyers", totals.tradeBuyers, `${basePath}/sellers?business=retail`],
    ["Wholesale Suppliers", totals.wholesaleSuppliers, `${basePath}/sellers?business=wholesale`],
    ["Low Stock", totals.lowStockProducts, `${basePath}/products?filter=low-stock&sort=stock-low`],
    ["Hidden Listings", totals.hiddenProducts, `${basePath}/products?filter=hidden`],
    ["Pending Orders", totals.pendingOrders, `${basePath}/orders?status=pending`],
    ["Active Offers", totals.activePromotions, `${basePath}/promotions?filter=active`],
    ["Free Gift Offers", totals.freeGiftPromotions, `${basePath}/promotions?filter=free-gift`],
    ["Coupon Offers", totals.couponPromotions, `${basePath}/promotions?filter=coupon`],
  ];

  return (
    <div style={{ padding: 24, display: "grid", gap: 22 }}>
      <section style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 16 }}>
        {cards.map(([label, value, to]) => (
          <Link key={label} to={to} style={{ ...cardStyle, textDecoration: "none", color: "inherit" }}>
            <div style={{ color: "#64748b", fontSize: 13, textTransform: "uppercase", letterSpacing: "0.08em" }}>{label}</div>
            <div style={{ fontSize: 28, fontWeight: 800, marginTop: 8 }}>{value}</div>
            <div style={{ marginTop: 8, color: "#0284c7", fontSize: 13, fontWeight: 800 }}>Open details</div>
          </Link>
        ))}
      </section>

      <section style={cardStyle}>
        <h2 style={{ marginTop: 0 }}>Seller Sales Report</h2>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 700 }}>
            <thead>
              <tr style={{ textAlign: "left", background: "#f8fafc" }}>
                <th style={th}>Seller</th>
                <th style={th}>Products</th>
                <th style={th}>Orders</th>
                <th style={th}>Revenue</th>
                <th style={th}>Status</th>
              </tr>
            </thead>
            <tbody>
              {sellerReport.map((row) => (
                <tr key={row.seller._id} style={{ borderBottom: "1px solid #e2e8f0" }}>
                  <td style={td}>
                    <strong>{row.seller.storeName}</strong>
                    <div style={{ fontSize: 13, color: "#64748b" }}>{row.seller.email}</div>
                  </td>
                  <td style={td}>{row.productCount}</td>
                  <td style={td}>{row.orderCount}</td>
                  <td style={td}>Rs.{Number(row.revenue || 0).toFixed(2)}</td>
                  <td style={td}>{row.seller.isApproved ? "Approved" : "Suspended"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section style={cardStyle}>
        <h2 style={{ marginTop: 0 }}>Recent Orders</h2>
        <div style={{ display: "grid", gap: 12 }}>
          {recentOrders.map((order) => (
            <div key={order._id} style={{ border: "1px solid #e2e8f0", borderRadius: 14, padding: 14 }}>
              <strong>{order.invoiceNumber || order.razorpay_order_id}</strong>
              <div style={{ color: "#475569", marginTop: 4 }}>
                {order.customer?.name || "Customer"} • {order.status} • Rs.{Number(order.amount || 0).toFixed(2)}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

const th = { padding: "12px 14px" };
const td = { padding: "12px 14px", verticalAlign: "top" };

export default AdminDashboard;
